import { axiosInstance } from '../../../../common/axiosInstans';

export default class TenantService {
    getTenants = async () => {
        try {
            const response = await axiosInstance.get('/tenants');
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    getTenant = async (tenantId: string) => {
        try {
            const response = await axiosInstance.get(`/tenants/${tenantId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    createTenant = async (tenant: any) => {
        try {
            const response = await axiosInstance.post('/tenants', tenant);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    activateTenant = async (tenantId: string) => {
        try {
            await axiosInstance.post(`/tenants/${tenantId}/activate`);
        } catch (error) {
            throw error;
        }
    };

    deactivateTenant = async (tenantId: string) => {
        try {
            await axiosInstance.post(`/tenants/${tenantId}/deactivate`);
        } catch (error) {
            throw error;
        }
    };

    updateLicens = async (tenantId: string, expiration: string) => {
        try {
            await axiosInstance.post(`/tenants/${tenantId}/upgrade`, {
                tenantId: tenantId,
                extendedExpiryDate: expiration,
            });
        } catch (error) {
            throw error;
        }
    };
}
